import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { SchedulesFacade } from '@library/store/schedules/schedules.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-sidebar-control-mode-card',
  templateUrl: './sidebar-control-mode-card.component.html',
  styleUrls: ['./sidebar-control-mode-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarControlModeCardComponent {

  constructor(
    private homesFacade: HomesFacade,
    private schedulesFacade: SchedulesFacade,
  ) {}

  async ngOnInit() {
    this.homesFacade.currentHomeId$.pipe(isDefined()).subscribe(async () => {
      const home = await firstValueFrom(this.homesFacade.currentHome$);
      this.schedulesFacade.loadOnlySchedules(home);
    });
  }

}
